import { DotsHorizontalIcon } from "@radix-ui/react-icons";
import { Row } from "@tanstack/react-table";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { Button } from "@/components/ui/button/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu/dropdown-menu";
import { LeaveApplication } from "./schema";
import { useCancelRequestModal } from "../cancel-leave-request-modal/use-cancel-request-modal";
// import { useTakeActionModal } from "../take-action-modal/use-action-modal";

interface DataTableRowActionsProps<TData> {
  row: Row<TData>;
}

export function DataTableRowActions<TData>({
  row,
}: DataTableRowActionsProps<TData>) {
  const originData = row.original as LeaveApplication;
  const navigate = useNavigate();

  const [open, setOpen] = useState(false);

  const { onOpenChange, setLeaveId } = useCancelRequestModal();

  return (
    <DropdownMenu open={open} onOpenChange={setOpen}>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          className="flex h-8 w-8 p-0 data-[state=open]:bg-muted"
        >
          <DotsHorizontalIcon className="h-4 w-4" />
          <span className="sr-only">Open menu</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-[160px]">
        {originData?.status === "Pending" && (
          <DropdownMenuItem
            onMouseDown={() => {
              navigate(`/employee/leave-applications/edit/${originData.id}`);
              setOpen(false);
            }}
          >
            Edit
          </DropdownMenuItem>
        )}
        <DropdownMenuItem
          onMouseDown={() => {
            setLeaveId(originData?.id);
            onOpenChange(true);
            setOpen(false);
          }}
        >
          Cancel Request
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
